import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";

export const ADMIN_AGENT_PAY_KEY = "adminAgentPayToVisit";
export const INSURANCE_AGENT_PAY_KEY = "insuranceAgentPayToVisit";

const ROLE_PAY_CONFIG = [
  { roleName: "agent admin", storageKey: ADMIN_AGENT_PAY_KEY },
  { roleName: "insurance agent", storageKey: INSURANCE_AGENT_PAY_KEY },
];

const normalizeUserNode = (payload) =>
  payload?.user ?? payload?.data?.user ?? payload;

const extractRoles = (payload) => {
  const roles = normalizeUserNode(payload)?.roles;
  return Array.isArray(roles) ? roles : [];
};

const hasRole = (payload, targetRole) =>
  extractRoles(payload).some(
    (role) =>
      role?.name &&
      role.name.toLowerCase() === targetRole.toLowerCase()
  );

const extractPayToVisit = (payload) => {
  const payToVisit = normalizeUserNode(payload)?.pay_to_visit;
  const numeric = Number(payToVisit);
  return Number.isFinite(numeric) ? numeric : null;
};

const persistRolePayToVisit = (payload, roleName, storageKey) => {
  try {
    if (typeof window === "undefined") return;
    if (!hasRole(payload, roleName)) {
      window.localStorage.removeItem(storageKey);
      return;
    }
    const value = extractPayToVisit(payload);
    if (value !== null) {
      window.localStorage.setItem(storageKey, value.toString());
    } else {
      window.localStorage.removeItem(storageKey);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      `[auth.module] No se pudo persistir pay_to_visit para ${roleName}:`,
      error
    );
  }
};

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          // console.log("Here what post returns", data);
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("verify")
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(state.user.token);
    ROLE_PAY_CONFIG.forEach(({ roleName, storageKey }) =>
      persistRolePayToVisit(user, roleName, storageKey)
    );
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    if (typeof window !== "undefined") {
      ROLE_PAY_CONFIG.forEach(({ storageKey }) =>
        window.localStorage.removeItem(storageKey)
      );
    }
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
